

export default function footer() {
  return (
    <>
      <footer className="page-footer font-small   sticky-Bottom" style={{ background: "green" }}>
        <div className="footer-copyright  text-center">
    
        </div>
      </footer>
    </>
  );
}
